module.exports = __webpack_public_path__ + "static/media/quote-list.45cb9a14.svg";